{
  "ribbon": "Demo stand-in for the Dodo Payments form. No real payment is made.",
  "notFound": "This checkout doesn't exist. Go back and start the payment again.",
  "email": "Email",
  "method": "Demo payment method",
  "methods": {
    "visa": "Visa that always succeeds",
    "mastercard": "Mastercard that always succeeds",
    "amex": "American Express that always succeeds",
    "paypal": "PayPal account that always succeeds",
    "apple_pay": "Apple Pay that always succeeds",
    "visa_declines": "Visa that the bank always declines"
  },
  "declined": "The bank declined the card and nothing was charged. Pick another method and try again.",
  "pay": "Pay",
  "save": "Save payment method"
}
